module.exports = __webpack_public_path__ + "img/didan.64bee892.png";